


import { Component, Vue, Prop } from "vue-property-decorator";

import { Subscription } from "App/Models";
import { Subscriptions } from "App";

@Component
export default class SubscriptionPlans extends Vue {
    @Prop() public Row!: Subscription;

    /* Une entrée par plan, façon Stripe : "Plan (produit1, produit2, …)".
       Les produits proviennent des lignes d'abonnement rattachées au plan. */
    private get plans(): string[] {
        const row = this.Row;

        if( row.Plans === undefined || row.Plans.length === 0 )
            return [];

        const lines = row.Lines || [];
        const seenPlan = new Set<number>();
        const result: string[] = [];

        for( const plan of row.Plans ) {
            if( seenPlan.has( plan.Id ) )
                continue;

            seenPlan.add( plan.Id );

            const planName = plan.Name || plan.Product.Name || "";

            const features: string[] = [];
            const seenFeature = new Set<string>();

            for( const line of lines ) {
                if( line.Plan === undefined || line.Plan.Id !== plan.Id )
                    continue;

                const name = line.Product.Name;

                if( name === undefined || name === "" || seenFeature.has( name ) )
                    continue;

                /* On n'ajoute pas en parenthèse le produit qui ne fait que répéter le plan
                   (le wrapper "plan" ou un produit homonyme du plan) : "Plus (plan)" doit
                   s'afficher simplement "Plus". Seuls les vrais add-ons restent listés. */
                const normalized = name.trim().toLowerCase();

                if( normalized === "plan" || normalized === planName.trim().toLowerCase() )
                    continue;

                seenFeature.add( name );
                features.push( name );
            }

            const featuresLabel = features.join( ", " ).trim();

            result.push(
                featuresLabel.length > 0
                    ? `${ planName } (${ featuresLabel })`
                    : planName
            );
        }

        return result;
    }

    /* Repli sur l'ancien titre si aucune ligne n'est chargée sur la liste. */
    private get fallback(): string {
        return Subscriptions.GenerateTitle( this.Row );
    }
}
